var _defs, _line, _ellipse, _g, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSealent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 176 146.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 2.5px;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke: #c1272d;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-1, .cls-3 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: #ab1f24;\n        font-family: MyriadPro-Regular, 'Myriad Pro';\n        font-size: 36px;\n      }\n\n      .cls-3 {\n        stroke-width: 3px;\n      }\n    "))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 87.4,
    y1: 33.94,
    x2: 87.4,
    y2: 110.91
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 88,
    cy: 73.43,
    rx: 86.5,
    ry: 71.93
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 25.73,
    y1: 23.12,
    x2: 54.96,
    y2: 46.13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 122.07,
    y1: 100.5,
    x2: 151.31,
    y2: 123.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 151.5,
    y1: 23.91,
    x2: 121.05,
    y2: 45.34
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 50.66,
    y1: 98.54,
    x2: 20.21,
    y2: 119.97
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 87.4,
    cy: 73.07,
    rx: 47.32,
    ry: 39.34
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(99.76 83.36)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "S"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSealent);
export default __webpack_public_path__ + "static/media/Sealent.90157ce4838184a9fc34652389856854.svg";
export { ForwardRef as ReactComponent };